import { Button } from "antd";
import PropTypes from "prop-types";
import { PlusOutlined } from "@ant-design/icons";
import { useTranslation } from "react-i18next";

const Add = ({
  loading = false,
  type = "primary",
  icon = <PlusOutlined />,
  title = "button.add",
  onClick = () => {},
  id = "btn-add",
  ...props
}) => {
  const { t } = useTranslation();

  const translatedTitle = title === "button.add" ? t(title) : title;

  return (
    <Button
      type={type}
      icon={icon}
      onClick={onClick}
      id={id}
      title={translatedTitle}
      loading={loading}
      {...props}
    >
      {translatedTitle}
    </Button>
  );
};

Add.propTypes = {
  loading: PropTypes.bool,
  type: PropTypes.string,
  icon: PropTypes.object,
  title: PropTypes.string,
  onClick: PropTypes.func,
  id: PropTypes.string,
};

export default Add;
